<template>
	<div id="app">
		<bigpage class="bigpage"></bigpage>
		<smallpagex class="smallpage"></smallpagex>
	</div>
</template>

<script>
import bigpage from './components/bigpage.vue'
import smallpagex from './components/smallpagex.vue'

export default {
  name: 'app',
  components: {
    bigpage,
		smallpagex
  }
}
</script>

<style scoped>
body{
	margin: 0;
	  padding: 0;
}
@media (min-width:1000px){
	.smallpage{
		display: none !important;
	}
}
@media (max-width:1000px){
	.bigpage{
		display: none !important;
	}
}
</style>
